<template>
    <adminTable ref="adminTableRef" :tableLoading="tableLoading" :totalList="totalList" v-model:page="page"
        v-model:limit="limit" v-model:searchForm="searchForm" :tableData="tableData" @search="getList"
        :hideSeachButton="true" :hideResetButton="true">
        <!-- <template v-slot:form-inline-items>
            <el-form-item>
                <el-input v-model="searchForm.keyword" placeholder="搜索关键字" clearable />
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.status" placeholder="状态" clearable>
                    <el-option v-for="item in stockStatusEnums" :label="item.label" :value="item.value"
                        :key="item.label" />
                </el-select>
            </el-form-item>
        </template> -->
        <template v-slot:query-button-right>
            <el-button type="primary" icon="CirclePlus" @click="editItem('add', {})" v-permission>添加期数</el-button>
        </template>
        <template v-slot:table>
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="phase_no" label="期数" width="80" />
            <el-table-column prop="title" label="标题" min-width="200" />
            <el-table-column prop="total_shares" label="总份额" width="120" />
            <el-table-column prop="sold_shares" label="已售份额" width="120">
                <template #default="scope">
                    {{ parseInt(scope.row.sold_shares) || 0 }}
                </template>
            </el-table-column>
            <el-table-column label="销售进度" width="150">
                <template #default="scope">
                    <el-progress 
                        :percentage="Math.min(100, Math.round(parseInt(scope.row.sold_shares || 0) / scope.row.total_shares * 100))" 
                        :stroke-width="12"
                        :format="(p) => p + '%'" />
                </template>
            </el-table-column>
            <el-table-column prop="start_time" label="开始时间" width="180" />
            <el-table-column prop="end_time" label="结束时间" width="180" />
            <el-table-column prop="status" label="状态" width="100">
                <template #default="scope">
                    <el-switch
                        v-model="scope.row.status"
                        :active-value="1"
                        :inactive-value="0"
                        @change="handleStatusChange(scope.row)"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间" width="180" />
            <el-table-column label="操作" width="200" fixed="right" v-if="currentUser.role == 0">
                <template #default="scope">
                    <el-button type="primary" icon="Edit" v-permission
                        @click="editItem('edit', scope.row)">编辑</el-button>
                    <el-button type="danger" icon="Delete" v-permission
                        @click="deleteItem(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </template>
        <el-dialog v-model="dialogFlag" :title="formType === 'add' ? '新增期数' : '编辑期数'" width="600">
            <el-form ref="editFormRef" :model="editRow" label-width="100px" :rules="rules">
                <el-form-item label="期数" prop="phase_no">
                    <el-input-number v-model="editRow.phase_no" :min="1" :step="1" style="width: 100%;" placeholder="请输入期数" />
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input v-model="editRow.title" placeholder="请输入标题" />
                </el-form-item>
                <el-form-item label="总份额" prop="total_shares">
                    <el-input-number v-model="editRow.total_shares" :min="0" :step="1000" style="width: 100%;" placeholder="请输入总份额" />
                </el-form-item>
                <el-form-item label="已售份额" prop="sold_shares">
                    <el-input-number v-model="editRow.sold_shares" :min="0" :step="100" style="width: 100%;" placeholder="请输入已售份额" />
                </el-form-item>
                <el-form-item label="开始时间" prop="start_time">
                    <el-date-picker v-model="editRow.start_time" type="datetime" placeholder="选择开始时间"
                        value-format="YYYY-MM-DD HH:mm:ss" style="width: 100%;" />
                </el-form-item>
                <el-form-item label="结束时间" prop="end_time">
                    <el-date-picker v-model="editRow.end_time" type="datetime" placeholder="选择结束时间"
                        value-format="YYYY-MM-DD HH:mm:ss" style="width: 100%;" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="editRow.status" placeholder="请选择状态" style="width: 100%;">
                        <el-option label="开启" :value="1" />
                        <el-option label="关闭" :value="0" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFlag = false">取消</el-button>
                    <el-button type="primary" @click="submitForm">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, shallowRef, onMounted, nextTick } from "vue";
import { stockStatusEnums, getLabelByVal } from "@/config/enums";
import { ElMessage, ElMessageBox } from "element-plus";
import { getTokenAUTH } from "@/utils/auth";
import { htmlDecodeByRegExp } from '@/utils/utils'
import * as echarts from 'echarts'


const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const searchForm = ref({
    status: "",
    phase_no: "",
});
const dialogFlag = ref(false);
const editFormRef = ref(null);
const adminTableRef = ref(null);
const formType = ref("add");
const headers = ref({})
const levelList = ref([]); // 等级列表

// K线图相关
const klineDialogFlag = ref(false);
const klineLoading = ref(false);
const klineChartRef = ref(null);
const currentStock = ref({});
const klineDate = ref('');
const klineInterval = ref('1s'); // 时间间隔
let klineChart = null;
let klineAllData = []; // 存储所有K线数据
let isLoadingMore = false; // 防止重复加载
let klinePage = 1; // 当前页码
let hasMoreData = true; // 是否还有更多数据

// 编辑K线数据相关
const editKlineDialogFlag = ref(false);
const editKlineLoading = ref(false);
const editKlineForm = ref({
    id: null,
    point_time: '',
    start_time: '',
    end_time: '',
    open_price: 0,
    close_price: 0,
    high_price: 0,
    low_price: 0,
    volume: 0
});
// 允许编辑的间隔列表
const editableIntervals = ['1s', '1m', '10m', '20m', '30m'];
let editKlineIndex = -1; // 记录编辑的索引

// 控制走势相关
const trendControlDialogFlag = ref(false);
const trendLoading = ref(false);
const trendFormRef = ref(null);
const trendForm = ref({
    target_price: 0,
    start_time: '',
    end_time: '',
    mode: 'smooth',
    volatility: 0.1
});
const trendRules = {
    target_price: [{ required: true, message: '请输入目标价格', trigger: 'blur' }],
    start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
    end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
    mode: [{ required: true, message: '请选择走势模式', trigger: 'change' }],
};

// 生成股票数据相关
const generateDialogFlag = ref(false);
const generateLoading = ref(false);
const generateFormRef = ref(null);
const generateForm = ref({
    stock_id: null,
    date: '',
    price_min: 220,
    price_max: 240,
    range_percent: 0.1,
    interval: '1s',
    max_step: 0.15,
    volume_avg: 1200,
    volume_min: 900,
    volume_max: 1400
});
const generateRules = {
    date: [{ required: true, message: '请选择日期', trigger: 'change' }],
    price_min: [{ required: true, message: '请输入价格最小值', trigger: 'blur' }],
    price_max: [{ required: true, message: '请输入价格最大值', trigger: 'blur' }],
    interval: [{ required: true, message: '请选择时间间隔', trigger: 'change' }],
};

onMounted(() => {
    headers.value['Accept-Token'] = getTokenAUTH()
    getList();
    getLevelList();
});
const { proxy } = getCurrentInstance()

// 获取等级列表
const getLevelList = async () => {
    const res = await proxy.$http({
        method: "get",
        url: "/Level/getLevelLists",
    });
    if (res.code == 0) {
        levelList.value = res.data.data || [];
    }
};

const editRow = ref({
    id: null,
    stock_id: 1,
    phase_no: 1,
    title: "",
    total_shares: 100000,
    sold_shares: 0,
    start_time: "",
    end_time: "",
    status: 1,
});

// 表单验证规则
const rules = {
    phase_no: [{ required: true, message: '请输入期数', trigger: 'blur' }],
    title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
    total_shares: [{ required: true, message: '请输入总份额', trigger: 'blur' }],
    start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
    end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
    status: [{ required: true, message: '请选择状态', trigger: 'change' }],
};

const successUpload = (res) => {
    editRow.value.icon = res.data.url;
};

const handleErr = (err) => {
    if (err.status == 320) {
        editRow.value.icon = JSON.parse(err.message).data.url;
    }
}
const editItem = (type, row = {}) => {
    formType.value = type;
    if (type === 'add') {
        // 新增时设置默认值
        editRow.value = {
            id: null,
            stock_id: 1,
            phase_no: 1,
            title: "",
            total_shares: 100000,
            sold_shares: 0,
            start_time: "",
            end_time: "",
            status: 1,
        };
    } else {
        // 编辑时使用现有数据
        editRow.value = {
            id: row.id,
            stock_id: row.stock_id || 1,
            phase_no: row.phase_no,
            title: row.title,
            total_shares: row.total_shares,
            sold_shares: parseInt(row.sold_shares) || 0,
            start_time: row.start_time,
            end_time: row.end_time,
            status: row.status,
        };
    }
    dialogFlag.value = true;
};
const showKLine = async (row) => {
    currentStock.value = row;
    klineDate.value = new Date().toISOString().split('T')[0]; // 默认今天
    klineAllData = []; // 重置数据
    klinePage = 1;
    hasMoreData = true;
    klineDialogFlag.value = true;
    await loadKlineData(false);
};

const onKlineDateChange = async () => {
    klineAllData = []; // 切换日期时重置数据
    klinePage = 1;
    hasMoreData = true;
    await loadKlineData(false);
};

const onKlineIntervalChange = async () => {
    klineAllData = []; // 切换间隔时重置数据
    klinePage = 1;
    hasMoreData = true;
    await loadKlineData(false);
};

// 保存加载更多前的dataZoom状态
let prevDataZoomState = null;
let prevDataCount = 0;

// 计算dataZoom的范围，加载更多时保持视图位置
const calculateDataZoomRange = (isLoadMore, addedCount, totalCount) => {
    if (!isLoadMore || !prevDataZoomState || prevDataCount === 0) {
        // 首次加载，显示最后50%的数据
        return { start: 50, end: 100 };
    }
    
    // 加载更多时，需要计算新的start/end以保持原有数据在视图中
    // 新数据加到前面，所以原来的数据索引都往后移了addedCount
    // 原来 prevDataCount 条数据，视图范围是 [prevStart%, prevEnd%]
    // 现在 totalCount 条数据，需要计算新的范围
    
    const prevStart = prevDataZoomState.start;
    const prevEnd = prevDataZoomState.end;
    
    // 原来可见的数据点索引范围
    const prevStartIndex = Math.floor(prevDataCount * prevStart / 100);
    const prevEndIndex = Math.floor(prevDataCount * prevEnd / 100);
    
    // 新数据加到前面后，原来可见的数据索引需要加上addedCount
    const newStartIndex = prevStartIndex + addedCount;
    const newEndIndex = prevEndIndex + addedCount;
    
    // 转换为新的百分比
    const newStart = Math.max(0, (newStartIndex / totalCount) * 100);
    const newEnd = Math.min(100, (newEndIndex / totalCount) * 100);
    
    return { start: newStart, end: newEnd };
};

const loadKlineData = async (isLoadMore = false) => {
    if (isLoadingMore) return;
    if (isLoadMore && !hasMoreData) return; // 没有更多数据了
    
    // 加载更多前，记录当前dataZoom的位置
    if (isLoadMore && klineChart) {
        const option = klineChart.getOption();
        if (option && option.dataZoom && option.dataZoom[0]) {
            prevDataZoomState = {
                start: option.dataZoom[0].start,
                end: option.dataZoom[0].end
            };
            prevDataCount = klineAllData.length;
        }
    }
    
    // 加载更多时不显示loading，避免闪烁
    if (!isLoadMore) {
        klineLoading.value = true;
    }
    isLoadingMore = true;
    
    await nextTick();
    
    try {
        const res = await proxy.$http({
            method: "get",
            url: "/Stock/klineList",
            params: {
                stock_id: currentStock.value.id,
                date: klineDate.value,
                interval: klineInterval.value,
                page: klinePage,
            },
        });
        
        if (res.code == 0) {
            let newList = res.data.list || [];
            if (newList.length > 0) {
                // 后端返回的是降序（新→旧），需要反转为升序（旧→新）
                newList = newList.reverse();
                
                if (isLoadMore) {
                    // 历史数据（更早的）追加到前面
                    klineAllData = [...newList, ...klineAllData];
                } else {
                    klineAllData = newList;
                }
                klinePage++; // 页码+1，准备加载下一页
                renderKlineChart(isLoadMore, newList.length);
            } else {
                hasMoreData = false; // 没有更多数据了
                if (!isLoadMore) {
                    klineAllData = [];
                    renderKlineChart(false, 0);
                }
            }
        } else {
            ElMessage.error(res.msg || '获取K线数据失败');
        }
    } catch (error) {
        ElMessage.error('获取K线数据失败');
    } finally {
        klineLoading.value = false;
        isLoadingMore = false;
    }
};

const renderKlineChart = (isLoadMore = false, addedCount = 0) => {
    if (!klineChartRef.value) return;
    
    // 如果不是加载更多，需要重新初始化图表
    if (!isLoadMore) {
        if (klineChart) {
            klineChart.dispose();
        }
        klineChart = echarts.init(klineChartRef.value);
        
        // 监听 dataZoom 事件，左滑到边界时加载更多
        let ignoreDataZoom = false;
        klineChart.on('datazoom', (params) => {
            // 忽略程序触发的 dataZoom 事件
            if (ignoreDataZoom) return;
            
            const option = klineChart.getOption();
            const dataZoom = option.dataZoom[0];
            // 当滑动到最左边（start 接近 0）且还有更多数据时加载
            if (dataZoom.start <= 2 && !isLoadingMore && hasMoreData) {
                loadKlineData(true);
            }
        });
        
        // 设置一个标志来区分用户操作和程序更新
        klineChart.setIgnoreDataZoom = (ignore) => {
            ignoreDataZoom = ignore;
        };
        
        // 根据间隔计算结束时间
        const calculateEndTime = (startTime, interval) => {
            const date = new Date(startTime);
            switch (interval) {
                case '1m':
                    date.setMinutes(date.getMinutes() + 1);
                    break;
                case '10m':
                    date.setMinutes(date.getMinutes() + 10);
                    break;
                case '20m':
                    date.setMinutes(date.getMinutes() + 20);
                    break;
                case '30m':
                    date.setMinutes(date.getMinutes() + 30);
                    break;
            }
            // 格式化为 YYYY-MM-DD HH:mm:ss
            const pad = (n) => n.toString().padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        };
        
        // 监听点击事件，编辑K线数据
        const handleKlineClick = (params) => {
            // 检查是否允许编辑的间隔
            if (!editableIntervals.includes(klineInterval.value)) {
                ElMessage.warning('当前时间间隔不支持编辑');
                return;
            }
            const dataIndex = params.dataIndex;
            const item = klineAllData[dataIndex];
            if (item) {
                editKlineIndex = dataIndex;
                
                if (klineInterval.value === '1s') {
                    // 1秒间隔：单点编辑
                    editKlineForm.value = {
                        id: item.id,
                        point_time: item.point_time,
                        start_time: '',
                        end_time: '',
                        open_price: parseFloat(item.open_price),
                        close_price: parseFloat(item.close_price),
                        high_price: parseFloat(item.high_price),
                        low_price: parseFloat(item.low_price),
                        volume: parseFloat(item.volume || 0)
                    };
                } else {
                    // 分钟间隔：根据点击的K线计算时间范围
                    const startTime = item.point_time;
                    const endTime = calculateEndTime(startTime, klineInterval.value);
                    editKlineForm.value = {
                        id: null,
                        point_time: '',
                        start_time: startTime,
                        end_time: endTime,
                        open_price: parseFloat(item.open_price),
                        close_price: parseFloat(item.close_price),
                        high_price: parseFloat(item.high_price),
                        low_price: parseFloat(item.low_price),
                        volume: parseFloat(item.volume || 0)
                    };
                }
                editKlineDialogFlag.value = true;
            }
        };
        klineChart.on('click', 'series.candlestick', handleKlineClick);
        klineChart.on('click', 'series.bar', handleKlineClick);
    }
    
    // 解析数据 - 使用全部数据
    const list = klineAllData;
    const dates = list.map(item => item.point_time);
    
    // 查找当前时间对应的K线索引
    const now = new Date();
    const currentTimeStr = now.toTimeString().slice(0, 8); // HH:mm:ss
    const todayStr = now.toISOString().split('T')[0]; // YYYY-MM-DD
    
    let currentIndex = -1;
    for (let i = list.length - 1; i >= 0; i--) {
        const pointTime = list[i].point_time;
        // 检查是否是今天的数据，且时间小于等于当前时间
        if (pointTime.startsWith(todayStr)) {
            const pointTimeStr = pointTime.split(' ')[1];
            if (pointTimeStr <= currentTimeStr) {
                currentIndex = i;
                break;
            }
        }
    }
    
    // 计算EMA
    const calculateEMA = (data, period) => {
        const ema = [];
        const multiplier = 2 / (period + 1);
        for (let i = 0; i < data.length; i++) {
            if (i === 0) {
                ema.push(data[i]);
            } else {
                ema.push((data[i] - ema[i - 1]) * multiplier + ema[i - 1]);
            }
        }
        return ema;
    };
    
    // 计算MACD
    const closePrices = list.map(item => parseFloat(item.close_price));
    const ema12 = calculateEMA(closePrices, 12);
    const ema26 = calculateEMA(closePrices, 26);
    const dif = ema12.map((val, i) => val - ema26[i]);
    const dea = calculateEMA(dif, 9);
    const macdData = dif.map((val, i) => ((val - dea[i]) * 2).toFixed(4));
    const difData = dif.map(val => val.toFixed(4));
    const deaData = dea.map(val => val.toFixed(4));
    
    // 生成K线数据，当前时间的K线使用特殊样式
    const klineData = list.map((item, index) => {
        const data = {
            value: [
                parseFloat(item.open_price),
                parseFloat(item.close_price),
                parseFloat(item.low_price),
                parseFloat(item.high_price)
            ]
        };
        // 高亮当前时间的K线
        if (index === currentIndex) {
            data.itemStyle = {
                color: '#ffeb3b',
                color0: '#ffeb3b',
                borderColor: '#ff9800',
                borderColor0: '#ff9800',
                borderWidth: 2
            };
        }
        return data;
    });
    
    const volumes = list.map((item, index) => {
        const data = {
            value: parseFloat(item.volume || 0)
        };
        // 高亮当前时间的成交量
        if (index === currentIndex) {
            data.itemStyle = {
                color: '#ff9800'
            };
        }
        return data;
    });
    
    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            },
            formatter: function (params) {
                const kline = params.find(p => p.seriesName === 'K线');
                const vol = params.find(p => p.seriesName === '成交量');
                const macd = params.find(p => p.seriesName === 'MACD');
                const dif = params.find(p => p.seriesName === 'DIF');
                const dea = params.find(p => p.seriesName === 'DEA');
                if (!kline) return '';
                
                // 直接从原始数据中获取，避免 ECharts 数据格式问题
                const dataIndex = kline.dataIndex;
                const item = list[dataIndex];
                if (!item) return '';
                
                return `<div style="font-weight:bold">${item.point_time}</div>
                    <div>开盘价: ${item.open_price}</div>
                    <div>收盘价: ${item.close_price}</div>
                    <div>最低价: ${item.low_price}</div>
                    <div>最高价: ${item.high_price}</div>
                    <div>成交量: ${item.volume || 0}</div>
                    <div style="margin-top:5px;border-top:1px solid #eee;padding-top:5px;">
                        ${dif ? `<div style="color:#ffeb3b">DIF: ${dif.data}</div>` : ''}
                        ${dea ? `<div style="color:#2196f3">DEA: ${dea.data}</div>` : ''}
                        ${macd ? `<div style="color:${macd.data >= 0 ? '#ef5350' : '#26a69a'}">MACD: ${macd.data}</div>` : ''}
                    </div>`;
            }
        },
        legend: {
            show: false
        },
        grid: [
            {
                left: '10%',
                right: '8%',
                top: 30,
                height: '40%'
            },
            {
                left: '10%',
                right: '8%',
                top: '55%',
                height: '12%'
            },
            {
                left: '10%',
                right: '8%',
                top: '72%',
                height: '15%'
            }
        ],
        xAxis: [
            {
                type: 'category',
                data: dates,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                splitLine: { show: false },
                min: 'dataMin',
                max: 'dataMax'
            },
            {
                type: 'category',
                gridIndex: 1,
                data: dates,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                axisTick: { show: false },
                splitLine: { show: false },
                axisLabel: { show: false },
                min: 'dataMin',
                max: 'dataMax'
            },
            {
                type: 'category',
                gridIndex: 2,
                data: dates,
                scale: true,
                boundaryGap: false,
                axisLine: { onZero: false },
                axisTick: { show: false },
                splitLine: { show: false },
                axisLabel: { show: false },
                min: 'dataMin',
                max: 'dataMax'
            }
        ],
        yAxis: [
            {
                scale: true,
                splitArea: {
                    show: true
                }
            },
            {
                scale: true,
                gridIndex: 1,
                splitNumber: 2,
                axisLabel: { show: false },
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: { show: false }
            },
            {
                scale: true,
                gridIndex: 2,
                splitNumber: 2,
                axisLabel: { show: true, fontSize: 10 },
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: { show: false }
            }
        ],
        dataZoom: [
            {
                type: 'inside',
                xAxisIndex: [0, 1, 2],
                ...calculateDataZoomRange(isLoadMore, addedCount, list.length)
            },
            {
                show: true,
                xAxisIndex: [0, 1, 2],
                type: 'slider',
                bottom: 10,
                ...calculateDataZoomRange(isLoadMore, addedCount, list.length)
            }
        ],
        series: [
            {
                name: 'K线',
                type: 'candlestick',
                data: klineData,
                itemStyle: {
                    color: '#ef5350',
                    color0: '#26a69a',
                    borderColor: '#ef5350',
                    borderColor0: '#26a69a'
                },
                ...(currentIndex >= 0 ? {
                    markPoint: {
                        symbol: 'pin',
                        symbolSize: 40,
                        data: [{
                            name: '当前',
                            coord: [currentIndex, parseFloat(list[currentIndex].high_price)],
                            value: '当前',
                            itemStyle: {
                                color: '#ff9800'
                            },
                            label: {
                                show: true,
                                formatter: '当前'
                            }
                        }]
                    }
                } : {})
            },
            {
                name: '成交量',
                type: 'bar',
                xAxisIndex: 1,
                yAxisIndex: 1,
                data: volumes,
                itemStyle: {
                    color: '#7fbe9e'
                }
            },
            {
                name: 'MACD',
                type: 'bar',
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: macdData,
                itemStyle: {
                    color: (params) => {
                        return params.data >= 0 ? '#ef5350' : '#26a69a';
                    }
                }
            },
            {
                name: 'DIF',
                type: 'line',
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: difData,
                smooth: true,
                symbol: 'none',
                lineStyle: {
                    width: 1,
                    color: '#ffeb3b'
                }
            },
            {
                name: 'DEA',
                type: 'line',
                xAxisIndex: 2,
                yAxisIndex: 2,
                data: deaData,
                smooth: true,
                symbol: 'none',
                lineStyle: {
                    width: 1,
                    color: '#2196f3'
                }
            }
        ]
    };
    
    // 加载更多时使用增量更新，减少闪烁
    // 设置标志，防止 setOption 触发 datazoom 事件
    if (isLoadMore && klineChart.setIgnoreDataZoom) {
        klineChart.setIgnoreDataZoom(true);
    }
    
    klineChart.setOption(option, {
        notMerge: !isLoadMore, // 加载更多时不清除之前的配置
        lazyUpdate: isLoadMore // 加载更多时延迟更新
    });
    
    // 恢复标志，延迟一下确保事件已处理
    if (isLoadMore && klineChart.setIgnoreDataZoom) {
        setTimeout(() => {
            klineChart.setIgnoreDataZoom(false);
        }, 100);
    }
    
    // 响应式（只在初始化时绑定）
    if (!isLoadMore) {
        window.addEventListener('resize', () => {
            klineChart && klineChart.resize();
        });
    }
};

// 保存编辑的K线数据
const saveKlineData = async () => {
    editKlineLoading.value = true;
    try {
        let res;
        
        if (klineInterval.value === '1s') {
            // 1秒间隔：调用单点编辑接口
            res = await proxy.$http({
                method: "post",
                url: "Stock/updateKlinePoint",
                data: {
                    id: editKlineForm.value.id,
                    open_price: editKlineForm.value.open_price,
                    high_price: editKlineForm.value.high_price,
                    low_price: editKlineForm.value.low_price,
                    close_price: editKlineForm.value.close_price,
                    volume: editKlineForm.value.volume
                }
            });
        } else {
            // 分钟间隔：调用批量修改接口
            res = await proxy.$http({
                method: "post",
                url: "Stock/updateKlinePoint",
                data: {
                    start_time: editKlineForm.value.start_time,
                    end_time: editKlineForm.value.end_time,
                    open_price: editKlineForm.value.open_price,
                    high_price: editKlineForm.value.high_price,
                    low_price: editKlineForm.value.low_price,
                    close_price: editKlineForm.value.close_price,
                    volume: editKlineForm.value.volume
                }
            });
        }
        
        if (res.code == 0) {
            ElMessage.success('保存成功');
            
            if (klineInterval.value === '1s') {
                // 更新本地数据（仅1秒间隔）
                if (editKlineIndex >= 0 && klineAllData[editKlineIndex]) {
                    klineAllData[editKlineIndex] = {
                        ...klineAllData[editKlineIndex],
                        open_price: editKlineForm.value.open_price.toString(),
                        close_price: editKlineForm.value.close_price.toString(),
                        high_price: editKlineForm.value.high_price.toString(),
                        low_price: editKlineForm.value.low_price.toString(),
                        volume: editKlineForm.value.volume.toString()
                    };
                    renderKlineChart(false);
                }
            } else {
                // 分钟间隔：重新加载数据
                klineAllData = [];
                klinePage = 1;
                hasMoreData = true;
                await loadKlineData(false);
            }
            
            editKlineDialogFlag.value = false;
        } else {
            ElMessage.error(res.msg || '保存失败');
        }
    } catch (error) {
        ElMessage.error('保存失败');
    } finally {
        editKlineLoading.value = false;
    }
};

// 显示走势控制弹窗
const showTrendControl = () => {
    // 获取当前最新价格作为参考
    const latestPrice = klineAllData.length > 0 
        ? parseFloat(klineAllData[klineAllData.length - 1].close_price) 
        : parseFloat(currentStock.value.latest_price) || 100;
    
    // 设置默认值
    const now = new Date();
    const startTime = new Date(now.getTime() + 60000); // 1分钟后
    const endTime = new Date(now.getTime() + 600000); // 10分钟后
    
    const formatDateTime = (date) => {
        const pad = (n) => n.toString().padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };
    
    trendForm.value = {
        target_price: Math.round(latestPrice * 1.05 * 100) / 100, // 默认目标价涨5%
        start_time: formatDateTime(startTime),
        end_time: formatDateTime(endTime),
        mode: 'smooth',
        volatility: 0.1
    };
    
    trendControlDialogFlag.value = true;
};

// 提交走势控制
const submitTrendControl = async () => {
    if (!trendFormRef.value) return;
    
    await trendFormRef.value.validate(async (valid) => {
        if (!valid) return;
        
        // 验证时间
        const startTime = new Date(trendForm.value.start_time);
        const endTime = new Date(trendForm.value.end_time);
        
        if (endTime <= startTime) {
            ElMessage.error('结束时间必须大于开始时间');
            return;
        }
        
        trendLoading.value = true;
        try {
            const res = await proxy.$http({
                method: "post",
                url: "Stock/setTargetPrice",
                data: {
                    stock_id: currentStock.value.id,
                    target_price: trendForm.value.target_price,
                    start_time: trendForm.value.start_time,
                    end_time: trendForm.value.end_time,
                    mode: trendForm.value.mode,
                    volatility: trendForm.value.volatility
                }
            });
            
            if (res.code == 0) {
                const data = res.data || {};
                ElMessage.success(`设置成功！已更新 ${data.updated_count || 0} 条数据，价格从 ${data.from_price} 变动到 ${data.to_price}`);
                trendControlDialogFlag.value = false;
                
                // 重新加载K线数据
                klineAllData = [];
                klinePage = 1;
                hasMoreData = true;
                await loadKlineData(false);
            } else {
                ElMessage.error(res.msg || '设置失败');
            }
        } catch (error) {
            ElMessage.error('设置失败');
        } finally {
            trendLoading.value = false;
        }
    });
};

const destroyChart = () => {
    if (klineChart) {
        klineChart.dispose();
        klineChart = null;
    }
    klineAllData = [];
    klinePage = 1;
    hasMoreData = true;
    isLoadingMore = false;
};

// 显示生成股票数据弹窗
const showGenerateKline = (row) => {
    currentStock.value = row;
    generateForm.value = {
        stock_id: row.id,
        date: new Date().toISOString().split('T')[0], // 默认今天
        price_min: parseFloat(row.latest_price) * 0.95 || 220,
        price_max: parseFloat(row.latest_price) * 1.05 || 240,
        range_percent: 0.1,
        interval: '1s',
        max_step: 0.15,
        volume_avg: 1200,
        volume_min: 900,
        volume_max: 1400
    };
    generateDialogFlag.value = true;
};

// 提交生成股票数据
const submitGenerateKline = async () => {
    if (!generateFormRef.value) return;
    
    await generateFormRef.value.validate(async (valid) => {
        if (!valid) return;
        
        generateLoading.value = true;
        try {
            const res = await proxy.$http({
                method: "post",
                url: "/stock/autoGenerateKline",
                data: generateForm.value
            });
            
            if (res.code == 0) {
                ElMessage.success(res.msg || '生成成功');
                generateDialogFlag.value = false;
            } else {
                ElMessage.error(res.msg || '生成失败');
            }
        } catch (error) {
            ElMessage.error('生成失败');
        } finally {
            generateLoading.value = false;
        }
    });
};

const setIndex = async (row) => {
    const res = await proxy.$http({
        method: "get",
        url: "Stock/updateStockIsHome?id=" + row.id + '&is_home=1',
    });
    if (res.code == 0) {
        getList();
        ElMessage({
            type: "success",
            message: res.msg,
        });
    }
};
const submitForm = async () => {
    if (!editFormRef.value) return;
    
    await editFormRef.value.validate(async (valid) => {
        if (!valid) return;
        
        const url = formType.value == "add" ? "/Stock/addOriginPhase" : "/Stock/updateOriginPhase";
        const data = {
            stock_id: editRow.value.stock_id || 1,
            phase_no: editRow.value.phase_no,
            title: editRow.value.title,
            total_shares: editRow.value.total_shares,
            sold_shares: editRow.value.sold_shares,
            start_time: editRow.value.start_time,
            end_time: editRow.value.end_time,
            status: editRow.value.status,
        };
        
        // 编辑时带上id
        if (formType.value !== "add") {
            data.id = editRow.value.id;
        }
        
        const res = await proxy.$http({
            method: "post",
            url: url,
            data: data,
        });

        if (res.code == 0) {
            dialogFlag.value = false;
            getList();
            ElMessage({
                type: "success",
                message: res.msg || '操作成功',
            });
        } else {
            ElMessage({
                type: "error",
                message: res.msg || '操作失败',
            });
        }
    });
};

// 状态开关切换
const handleStatusChange = async (row) => {
    try {
        const res = await proxy.$http({
            method: "post",
            url: "/Stock/updateOriginPhaseStatus",
            data: {
                id: row.id,
                status: row.status
            }
        });
        if (res.code == 0) {
            ElMessage.success(res.msg || '状态更新成功');
        } else {
            // 失败时恢复原状态
            row.status = row.status == 1 ? 0 : 1;
            ElMessage.error(res.msg || '状态更新失败');
        }
    } catch (error) {
        // 异常时恢复原状态
        row.status = row.status == 1 ? 0 : 1;
        ElMessage.error('状态更新失败');
    }
};

const deleteItem = (row) => {
    ElMessageBox.confirm("确定要删除该期数吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
    })
        .then(async () => {
            const res = await proxy.$http({
                method: "post",
                url: "/Stock/deleteOriginPhase",
                data: { id: row.id }
            });
            if (res.code == 0) {
                ElMessage.success(res.msg || '删除成功');
                getList();
            } else {
                ElMessage.error(res.msg || '删除失败');
            }
        })
        .catch(() => {
            // 取消删除
        });
};


// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();
const editorRef2 = shallowRef(); // 注意事项编辑器

// 内容 HTML
const mode = ref("default");

const toolbarConfig = {};
const editorConfig = {
    placeholder: "请输入规则内容...",
    MENU_CONF: {
        uploadImage: {
            fieldName: "file",
            maxFileSize: 10 * 1024 * 1024, // 10M
            server: proxy.BASE_API_URL + "index/uploadX",
            headers: {
                "Accept-Token": getTokenAUTH(),
            },
            customInsert(res, insertFn) {
                const url = proxy.IMG_BASE_URL + res.data.url;
                const alt = res.data.alt
                const href = res.data.href
                insertFn(url, alt, href);
            },
        },
    },
};
const handleCreated = (editor) => {
    editorRef.value = editor; // 记录 editor 实例，重要！
};

const handleCreated2 = (editor) => {
    editorRef2.value = editor; // 记录注意事项编辑器实例
};


const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
    tableLoading.value = true;
    const res = await proxy.$http({
        method: "get",
        url: "/Stock/getOriginPhaseLists",
        params: {
            stock_id: 1, // 写死为1
            page: page.value,
            limit: limit.value,
            ...searchForm.value,
        },
    });
    tableLoading.value = false;
    if (res.code == 0) {
        tableData.value = res.data.data;
        totalList.value = res.data.total;
    }
};
</script>

<style lang="less" scoped>
.form-item-tip {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    margin-top: 4px;
}

.kline-tip {
    font-size: 12px;
    color: #67c23a;
    margin-bottom: 10px;
}
</style>
